angular.module('impactx.ruleset').controller('RuleInvoiceListCtrl', ['$routeParams', 'selectedListItems', 'ConfirmationService',
    'TranslationService', 'ToastService', 'dataGen', RuleInvoiceListCtrl]);

function RuleInvoiceListCtrl($routeParams, selectedListItems,  ConfirmationService, TranslationService, ToastService, dataGen) {
    var ctrl = this;
    this.getDetailLink = function() {
        if (selectedListItems.getFirstSelectedItem()){
            return selectedListItems.getFirstSelectedItem().destination + "/" + selectedListItems.getFirstSelectedId() + "/" + $routeParams.RULESETId + "/" +
                selectedListItems.getFirstSelectedItem().ruleType;
        }
        else
        {
            return "";
        }
    };

    this.getRuleUserLink = function() {
        return "ruleuserlist/invoice/" + selectedListItems.getFirstSelectedId()
    };

    this.getRuleUserGroupLink = function() {
        return "ruleusergroup/" + selectedListItems.getFirstSelectedId()
    };

    this.canDelete = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canDelete.value;
    };

    this.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event,
            TranslationService.get('confirmDelete'), TranslationService.get('delete'), TranslationService.get('abort'));
    };

    this.delete = function() {
        dataGen.postAsForm({}, {id: selectedListItems.getFirstSelectedId()}, "/ruleset/deleterule").then(function () {
            ctrl.meta.refreshListData({unselectRow: selectedListItems.getFirstSelectedItem()});
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        })
    };

    var buttonDefinition = [
        {label: "details", linkFunction: ctrl.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'EditRuleSet'},
        {label: "ruleuser", linkFunction: ctrl.getRuleUserLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'EditRuleSet'},
        {label: "ruleusergroup", linkFunction: ctrl.getRuleUserGroupLink, type: 'link', condition: selectedListItems.isSingleSelection, process: 'EditRuleSet'},
        {label: "delete", action: ctrl.deleteDialog, condition: ctrl.canDelete, process: 'EditRuleSet'}
    ];

    this.meta = {
        rowTemplate: 'modules/ruleset/templates/ruleslist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/ruleset/listrulesinvoice',
        ctrl: this,
        id: "ruleinvoicelist",
        valuesInteger: [{name:"RULESETId", value: $routeParams.RULESETId},
            {name:"RULETYPE", value: 50}],
        mainAction : {id:"new", link: "#/ruleinvoice/0/" + $routeParams.RULESETId + "/" + 50 , icon:"mdi-plus"},
        buttonDefinition: buttonDefinition
    };

    this.getMeta = function () {
        return this.meta;
    };
}